import { useState } from "react";
import { supabase } from "../supabase";
import { C } from "../lib/constants";
import { ini } from "../lib/helpers";
import { Btn } from "./ui/Btn";
import { Inp } from "./ui/Inp";
import { TopNav } from "./ui/TopNav";

export const RegSupervisor = ({setScreen, user}) => {
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    nombre:"", apellidos:"", titulo:"Ing.", phone:"", email:"",
    cedula:"", cedula_doc:false,
    especialidades:[], otrasEsp:"",
    exp:"", universidad:"", anio_egreso:"",
    zonas:[], disponibilidad:[],
    foto:false, titulo_doc:false,
    metodo_cobro:"mercadopago",
    mp_cuenta:"", clabe:"", banco:"",
    acepta_reglamento:false, acepta_chat:false,
  });
  const [done, setDone] = useState(false);
  const [saving, setSaving] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [validationMsg, setValidationMsg] = useState("");
  const upd = (k,v) => { setValidationMsg(""); setErrorMsg(""); setForm(f=>({...f,[k]:v})); };
  const toggle = (k, val) => { setValidationMsg(""); setForm(f=>({...f,[k]:f[k].includes(val)?f[k].filter(x=>x!==val):[...f[k],val]})); };

  const goSupervisorStep = (nextStep) => {
    setErrorMsg("");
    if (nextStep === 2) {
      if (!form.nombre || !form.apellidos || !form.phone) return setValidationMsg("Completa nombre, apellidos y teléfono para continuar.");
    }
    if (nextStep === 3) {
      const cuentaOk = form.metodo_cobro === "mercadopago" ? form.mp_cuenta : (form.clabe && form.banco);
      if (!form.cedula || !form.exp) return setValidationMsg("Agrega cédula y años de experiencia para continuar.");
      if (!form.especialidades.length && !form.otrasEsp) return setValidationMsg("Selecciona una especialidad o escribe otra especialidad.");
      if (!cuentaOk) return setValidationMsg("Registra tu cuenta de cobro para continuar.");
    }
    if (nextStep === 4) {
      if (!form.disponibilidad.length) return setValidationMsg("Selecciona al menos un día disponible.");
      if (!form.zonas.length) return setValidationMsg("Selecciona al menos una zona de cobertura.");
    }
    setValidationMsg("");
    setStep(nextStep);
    try { window.scrollTo({top:0, behavior:"smooth"}); } catch {}
  };

  const guardarSupervisor = async () => {
    setSaving(true);
    setErrorMsg("");

    const { error } = await supabase.from("supervisores").upsert([{
      user_id: user?.id || null,
      nombre: `${form.titulo} ${form.nombre} ${form.apellidos}`,
      telefono: form.phone,
      especialidad: form.especialidades.slice(0,2).join(" · ") || form.otrasEsp || "Supervisión general",
      exp: parseInt(form.exp) || 0,
      cedula: form.cedula,
      avatar: ini(`${form.nombre} ${form.apellidos}` || "S"),
      color: C.blue,
      disponible: true,
      precio: 499,
      calificacion: 0,
      "reseñas": 0,
      banco: form.banco,
      clabe: form.clabe,
      metodo_cobro: form.metodo_cobro || "mercadopago",
      mp_account: form.mp_cuenta,
    }]);

    setSaving(false);

    if (error) {
      console.warn("Error al guardar supervisor:", error);
      setErrorMsg(error.message);
      window.ficioToast?.("Error al guardar: " + error.message, "error");
      return;
    }

    setDone(true);
  };

  const ESPECIALIDADES = ["Estructuras y cimentaciones","Instalaciones hidráulicas","Instalaciones eléctricas","Diseño y acabados","Supervisión general de obra","Topografía","Valuación inmobiliaria","Impermeabilización","Seguridad estructural","Diseño arquitectónico"];
  const ZONAS_MX = ["Centro","Chapultepec","Las Fuentes","Independencia","El Toreo","Infonavit","Bachigualato","Toda la ciudad"];
  const DISPONIBILIDAD = ["Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"];

  if(done) return (
    <div style={{minHeight:"100vh",background:C.bg,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{maxWidth:480,width:"100%",textAlign:"center"}}>
        <div style={{fontSize:72,marginBottom:16}}>🏗️</div>
        <div style={{fontFamily:"'Georgia',serif",fontSize:28,fontWeight:800,color:C.text,marginBottom:8}}>¡Solicitud enviada!</div>
        <div style={{color:C.sub,fontSize:14,lineHeight:1.6,marginBottom:16}}>Verificamos tu cédula en la SEP y tu documentación en <strong>24–48 horas hábiles</strong>. Te notificamos por WhatsApp cuando tu perfil esté activo.</div>
        <div style={{background:C.greenL,border:`1.5px solid ${C.green}30`,borderRadius:14,padding:16,marginBottom:24,textAlign:"left"}}>
          {[["Nombre",`${form.titulo} ${form.nombre} ${form.apellidos}`],["Cédula SEP",form.cedula],["Especialidad principal",form.especialidades[0]||"—"],["Ingreso por visita","$349 pesos"],["Retención Ficio","$150 pesos"]].map(([k,v])=>(
            <div key={k} style={{display:"flex",justifyContent:"space-between",marginBottom:6,paddingBottom:6,borderBottom:`1px solid ${C.green}20`}}>
              <span style={{color:C.sub,fontSize:12}}>{k}</span>
              <span style={{color:C.text,fontSize:12,fontWeight:700}}>{v}</span>
            </div>
          ))}
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          <Btn full color={C.green} onClick={()=>setScreen("directory")}>Ver el directorio →</Btn>
          <Btn full outline color={C.green} onClick={()=>setScreen("landing")}>Ir al inicio</Btn>
        </div>
      </div>
    </div>
  );

  const stepLabel = ["Datos personales","Perfil profesional","Disponibilidad","Documentos y reglamento"];

  return (
    <div style={{minHeight:"100vh",background:C.bg,paddingBottom:40}}>
      <TopNav setScreen={setScreen}
        back={step>1?()=>setStep(s=>s-1):"landing"}
        backLabel={step>1?`Paso ${step-1}`:"Inicio"}
        title="Registro de Supervisor"
        right={<div style={{display:"flex",gap:5}}>{[1,2,3,4].map(s=><div key={s} style={{width:24,height:5,borderRadius:3,background:s<=step?C.green:C.faint,transition:"background 0.3s"}}/>)}</div>}/>

      <div style={{maxWidth:560,margin:"0 auto",padding:"24px 20px"}}>

        {/* Step label */}
        <div style={{background:C.greenL,border:`1.5px solid ${C.green}25`,borderRadius:10,padding:"8px 14px",marginBottom:20,display:"flex",alignItems:"center",gap:8}}>
          <span style={{color:C.green,fontWeight:800,fontSize:13}}>Paso {step} de 4</span>
          <span style={{color:C.sub,fontSize:12}}>— {stepLabel[step-1]}</span>
        </div>
        {validationMsg && <div style={{background:C.redL,border:`1px solid ${C.red}30`,borderRadius:12,padding:"10px 12px",color:C.red,fontSize:12,marginBottom:14,fontWeight:700}}>{validationMsg}</div>}

        {/* ── PASO 1: DATOS PERSONALES ── */}
        {step===1 && (
          <div>
            <div style={{marginBottom:22}}>
              <div style={{fontFamily:"'Georgia',serif",fontSize:24,fontWeight:800,color:C.text,marginBottom:6}}>Datos personales</div>
              <div style={{color:C.muted,fontSize:13}}>Información que aparecerá en tu perfil público de Ficio.</div>
            </div>

            {/* Título */}
            <div style={{marginBottom:16}}>
              <div style={{color:C.sub,fontSize:11,fontWeight:700,letterSpacing:0.8,textTransform:"uppercase",marginBottom:8}}>Título profesional</div>
              <div style={{display:"flex",gap:8}}>
                {["Ing.","Arq.","M.C.","Dr."].map(t=>(
                  <button key={t} onClick={()=>upd("titulo",t)} style={{flex:1,background:form.titulo===t?C.green:C.surface,border:`1.5px solid ${form.titulo===t?C.green:C.border}`,borderRadius:10,padding:"10px 0",color:form.titulo===t?"#fff":C.sub,fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif"}}>{t}</button>
                ))}
              </div>
            </div>

            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <Inp label="Nombre(s)" placeholder="José" value={form.nombre} onChange={e=>upd("nombre",e.target.value)} icon="👤"/>
              <Inp label="Apellidos" placeholder="Martínez López" value={form.apellidos} onChange={e=>upd("apellidos",e.target.value)} icon="👤"/>
            </div>
            <Inp label="Teléfono / WhatsApp" type="tel" placeholder="10 dígitos sin espacios" value={form.phone} onChange={e=>upd("phone",e.target.value)} icon="📱"/>
            <Inp label="Correo electrónico" type="email" placeholder="tu@correo.com" value={form.email} onChange={e=>upd("email",e.target.value)} icon="✉️"/>

            <div style={{background:C.accentL,border:`1.5px solid ${C.accent}25`,borderRadius:12,padding:"12px 14px",marginBottom:20}}>
              <div style={{color:C.accent,fontSize:12,fontWeight:700,marginBottom:2}}>🔒 Privacidad</div>
              <div style={{color:C.sub,fontSize:12}}>Tu correo y teléfono nunca se muestran públicamente. El contacto ocurre solo dentro del chat de Ficio.</div>
            </div>
            <Btn full color={C.green} onClick={()=>goSupervisorStep(2)}>Continuar →</Btn>
          </div>
        )}

        {/* ── PASO 2: PERFIL PROFESIONAL ── */}
        {step===2 && (
          <div>
            <div style={{marginBottom:22}}>
              <div style={{fontFamily:"'Georgia',serif",fontSize:24,fontWeight:800,color:C.text,marginBottom:6}}>Perfil profesional</div>
              <div style={{color:C.muted,fontSize:13}}>Lo que los clientes ven al elegirte como supervisor.</div>
            </div>

            <Inp label="Número de cédula profesional SEP" placeholder="Ej: 8901234" value={form.cedula} onChange={e=>upd("cedula",e.target.value)} icon="🪪"/>
            <Inp label="Universidad / Institución" placeholder="Ej: UAS, IPN, UNAM..." value={form.universidad} onChange={e=>upd("universidad",e.target.value)} icon="🎓"/>
            <Inp label="Año de egreso" type="number" placeholder="Ej: 2008" value={form.anio_egreso} onChange={e=>upd("anio_egreso",e.target.value)} icon="📅"/>
            <Inp label="Años de experiencia en campo" type="number" placeholder="Ej: 15" value={form.exp} onChange={e=>upd("exp",e.target.value)} icon="🏗️"/>

            <div style={{marginBottom:16}}>
              <div style={{color:C.sub,fontSize:11,fontWeight:700,letterSpacing:0.8,textTransform:"uppercase",marginBottom:8}}>Especialidades (selecciona las que apliquen)</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                {ESPECIALIDADES.map(e=>{
                  const on=form.especialidades.includes(e);
                  return <button key={e} onClick={()=>toggle("especialidades",e)} style={{background:on?C.green:C.surface,border:`1.5px solid ${on?C.green:C.border}`,borderRadius:20,padding:"7px 14px",color:on?"#fff":C.sub,fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",transition:"all 0.15s"}}>{e}</button>;
                })}
              </div>
            </div>

            <Inp label="Otras especialidades (opcional)" placeholder="Describe cualquier otra área de expertise..." value={form.otrasEsp} onChange={e=>upd("otrasEsp",e.target.value)} icon="➕"/>

            {/* Cuenta de cobro */}
            <div style={{marginBottom:18}}>
              <div style={{color:C.sub,fontSize:11,fontWeight:700,letterSpacing:0.8,textTransform:"uppercase",marginBottom:8}}>💳 ¿Dónde quieres recibir tus $350 por visita?</div>
              <div style={{display:"flex",gap:8,marginBottom:14}}>
                {[["mercadopago","📱","Mercado Pago"],["transferencia","🏦","Transferencia SPEI"]].map(([val,icon,label])=>(
                  <button key={val} onClick={()=>upd("metodo_cobro",val)} style={{flex:1,background:form.metodo_cobro===val?C.green:C.surface,border:`1.5px solid ${form.metodo_cobro===val?C.green:C.border}`,borderRadius:12,padding:"12px 10px",color:form.metodo_cobro===val?"#fff":C.sub,cursor:"pointer",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",transition:"all 0.15s"}}>
                    <div style={{fontSize:22,marginBottom:4}}>{icon}</div>
                    <div style={{fontSize:12,fontWeight:700}}>{label}</div>
                  </button>
                ))}
              </div>

              {form.metodo_cobro==="mercadopago" && (
                <div>
                  <Inp label="Correo o teléfono de tu cuenta Mercado Pago" placeholder="Ej: tu@correo.com o 10 dígitos sin espacios" value={form.mp_cuenta} onChange={e=>upd("mp_cuenta",e.target.value)} icon="📱"/>
                  <div style={{background:"#E8F4FD",border:"1px solid #2558A820",borderRadius:10,padding:"10px 14px"}}>
                    <div style={{color:C.blue,fontSize:11,fontWeight:700,marginBottom:3}}>ℹ️ ¿Cómo funciona?</div>
                    <div style={{color:C.sub,fontSize:11,lineHeight:1.5}}>Cuando el cliente confirma el pago de $500 dentro de Ficio, los $350 se depositan automáticamente en tu cuenta de Mercado Pago. Sin esperas, sin intermediarios.</div>
                  </div>
                </div>
              )}

              {form.metodo_cobro==="transferencia" && (
                <div>
                  <Inp label="CLABE interbancaria (18 dígitos)" placeholder="000000000000000000" value={form.clabe} onChange={e=>upd("clabe",e.target.value)} icon="🏦"/>
                  <Inp label="Banco" placeholder="Ej: BBVA, Banorte, HSBC..." value={form.banco} onChange={e=>upd("banco",e.target.value)} icon="🏛️"/>
                  <div style={{background:"#FFFDE7",border:"1px solid #F9A82540",borderRadius:10,padding:"10px 14px"}}>
                    <div style={{color:"#795548",fontSize:11,fontWeight:700,marginBottom:3}}>⏱️ Tiempo de acreditación</div>
                    <div style={{color:"#795548",fontSize:11,lineHeight:1.5}}>Las transferencias SPEI se procesan en máximo 24 horas hábiles después de confirmada la supervisión.</div>
                  </div>
                </div>
              )}
            </div>

            <div style={{background:C.greenL,border:`1.5px solid ${C.green}25`,borderRadius:14,padding:16,marginBottom:20}}>
              <div style={{color:C.green,fontWeight:700,fontSize:13,marginBottom:8}}>💰 Tu ingreso estimado</div>
              {[["Por cada visita","$349 pesos"],["Ficio retiene","$150"],["5 visitas/mes","~$1,750 pesos"],["10 visitas/mes","~$3,500 pesos"],["Sin cuota mensual","Gratis registrarse"]].map(([k,v])=>(
                <div key={k} style={{display:"flex",justifyContent:"space-between",marginBottom:5,paddingBottom:5,borderBottom:`1px solid ${C.green}20`}}>
                  <span style={{color:C.sub,fontSize:12}}>{k}</span>
                  <span style={{color:C.green,fontSize:12,fontWeight:700}}>{v}</span>
                </div>
              ))}
            </div>
            <Btn full color={C.green} onClick={()=>goSupervisorStep(3)}>Continuar →</Btn>
            <div style={{color:C.muted,fontSize:11,textAlign:"center",marginTop:8}}>Selecciona al menos una especialidad y registra tu cuenta de cobro</div>
          </div>
        )}

        {/* ── PASO 3: DISPONIBILIDAD ── */}
        {step===3 && (
          <div>
            <div style={{marginBottom:22}}>
              <div style={{fontFamily:"'Georgia',serif",fontSize:24,fontWeight:800,color:C.text,marginBottom:6}}>Disponibilidad</div>
              <div style={{color:C.muted,fontSize:13}}>Tú controlas cuándo y dónde supervisas. Puedes cambiar esto después.</div>
            </div>

            <div style={{marginBottom:18}}>
              <div style={{color:C.sub,fontSize:11,fontWeight:700,letterSpacing:0.8,textTransform:"uppercase",marginBottom:8}}>Días disponibles para visitas</div>
              <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                {DISPONIBILIDAD.map(d=>{
                  const on=form.disponibilidad.includes(d);
                  return <button key={d} onClick={()=>toggle("disponibilidad",d)} style={{background:on?C.green:C.surface,border:`1.5px solid ${on?C.green:C.border}`,borderRadius:10,padding:"10px 14px",color:on?"#fff":C.sub,fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",transition:"all 0.15s"}}>{d}</button>;
                })}
              </div>
            </div>

            <div style={{marginBottom:18}}>
              <div style={{color:C.sub,fontSize:11,fontWeight:700,letterSpacing:0.8,textTransform:"uppercase",marginBottom:8}}>Zonas de cobertura en Los Mochis</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                {ZONAS_MX.map(z=>{
                  const on=form.zonas.includes(z);
                  return <button key={z} onClick={()=>toggle("zonas",z)} style={{background:on?C.blue:C.surface,border:`1.5px solid ${on?C.blue:C.border}`,borderRadius:20,padding:"7px 14px",color:on?"#fff":C.sub,fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",transition:"all 0.15s"}}>{z}</button>;
                })}
              </div>
            </div>

            <div style={{background:C.blueL,border:`1.5px solid ${C.blue}25`,borderRadius:12,padding:"12px 14px",marginBottom:20}}>
              <div style={{color:C.blue,fontWeight:700,fontSize:12,marginBottom:4}}>📍 Expansión futura</div>
              <div style={{color:C.sub,fontSize:12}}>Cuando Ficio llegue a otras ciudades podrás agregar más zonas desde tu perfil.</div>
            </div>
            <Btn full color={C.green} onClick={()=>goSupervisorStep(4)}>Continuar →</Btn>
            <div style={{color:C.muted,fontSize:11,textAlign:"center",marginTop:8}}>Selecciona al menos un día y una zona</div>
          </div>
        )}

        {/* ── PASO 4: DOCUMENTOS Y REGLAMENTO ── */}
        {step===4 && (
          <div>
            <div style={{marginBottom:22}}>
              <div style={{fontFamily:"'Georgia',serif",fontSize:24,fontWeight:800,color:C.text,marginBottom:6}}>Documentos y reglamento</div>
              <div style={{color:C.muted,fontSize:13}}>Verificamos tu cédula con la SEP antes de activar tu perfil.</div>
            </div>

            {/* Documentos */}
            <div style={{marginBottom:18}}>
              <div style={{color:C.sub,fontSize:11,fontWeight:700,letterSpacing:0.8,textTransform:"uppercase",marginBottom:10}}>Documentos requeridos</div>
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                {[{key:"foto",icon:"📸",title:"Foto profesional",sub:"Rostro visible, fondo claro"},{key:"titulo_doc",icon:"📄",title:"Título o cédula (foto)",sub:"Frente legible"},{key:"cedula_doc",icon:"🪪",title:"INE o pasaporte",sub:"Identificación oficial vigente"}].map(d=>(
                  <div key={d.key} onClick={()=>upd(d.key,!form[d.key])} style={{background:form[d.key]?C.greenL:C.surface,border:`1.5px dashed ${form[d.key]?C.green:C.border}`,borderRadius:14,padding:"16px",display:"flex",gap:14,alignItems:"center",cursor:"pointer",transition:"all 0.2s"}}>
                    <div style={{fontSize:28}}>{form[d.key]?"✅":d.icon}</div>
                    <div style={{flex:1}}>
                      <div style={{color:form[d.key]?C.green:C.text,fontSize:14,fontWeight:700,marginBottom:2}}>{form[d.key]?"Cargado correctamente":d.title}</div>
                      <div style={{color:C.muted,fontSize:12}}>{d.sub}</div>
                    </div>
                    {!form[d.key]&&<div style={{color:C.accent,fontSize:12,fontWeight:600}}>Subir</div>}
                  </div>
                ))}
              </div>
            </div>

            {/* Reglamento */}
            <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:14,padding:16,marginBottom:14,boxShadow:"0 2px 6px rgba(0,0,0,0.04)"}}>
              <div style={{color:C.text,fontWeight:700,fontSize:13,marginBottom:12}}>📋 Reglamento del supervisor Ficio</div>
              {["Nunca compartir datos de contacto personal con clientes fuera de Ficio","El chat con el cliente ocurre exclusivamente dentro de la plataforma","El reporte debe subirse el mismo día de la visita","El reporte solo puede firmarlo el supervisor — no puede delegarse","Si el cliente reporta contacto directo fuera de Ficio, el perfil se suspende","El dictamen técnico es responsabilidad profesional del supervisor firmante","Ficio retiene $150 de cada visita como comisión de plataforma"].map(r=>(
                <div key={r} style={{display:"flex",gap:8,marginBottom:8,alignItems:"flex-start"}}>
                  <span style={{color:C.blue,fontWeight:700,fontSize:13,flexShrink:0}}>·</span>
                  <span style={{color:C.sub,fontSize:12,lineHeight:1.5}}>{r}</span>
                </div>
              ))}
            </div>

            {/* Checkboxes de aceptación */}
            <div style={{display:"flex",flexDirection:"column",gap:10,marginBottom:20}}>
              {[[
                "acepta_reglamento",
                "Acepto el reglamento completo del supervisor Ficio y entiendo que su incumplimiento puede resultar en la suspensión de mi perfil."
              ],[
                "acepta_chat",
                "Entiendo que el contacto con clientes es exclusivamente dentro de Ficio y nunca compartiré mi número personal."
              ]].map(([key,texto])=>(
                <div key={key} onClick={()=>upd(key,!form[key])} style={{display:"flex",gap:12,alignItems:"flex-start",cursor:"pointer",background:form[key]?C.greenL:C.surface,border:`1.5px solid ${form[key]?C.green:C.border}`,borderRadius:12,padding:"12px 14px",transition:"all 0.15s"}}>
                  <div style={{width:22,height:22,borderRadius:6,border:`2px solid ${form[key]?C.green:C.border}`,background:form[key]?C.green:"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>
                    {form[key]&&<span style={{color:"#fff",fontSize:13,fontWeight:800}}>✓</span>}
                  </div>
                  <span style={{color:form[key]?C.green:C.sub,fontSize:12,lineHeight:1.5}}>{texto}</span>
                </div>
              ))}
            </div>

            {/* Resumen */}
            <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:14,padding:16,marginBottom:20,boxShadow:"0 2px 6px rgba(0,0,0,0.04)"}}>
              <div style={{color:C.text,fontWeight:700,fontSize:13,marginBottom:10}}>Resumen de tu registro</div>
              {[["Nombre",`${form.titulo} ${form.nombre} ${form.apellidos}`],["Cédula SEP",form.cedula||"—"],["Especialidades",form.especialidades.slice(0,2).join(", ")||(form.especialidades[0]||"—")],["Días disponibles",form.disponibilidad.join(", ")||"—"],["Zonas",form.zonas.join(", ")||"—"],["Cuenta de cobro",form.metodo_cobro==="mercadopago"?`Mercado Pago · ${form.mp_cuenta||"—"}`:`SPEI · ${form.banco||"—"}`]].map(([k,v])=>(
                <div key={k} style={{display:"flex",justifyContent:"space-between",marginBottom:6,paddingBottom:6,borderBottom:`1px solid ${C.divider}`}}>
                  <span style={{color:C.muted,fontSize:12}}>{k}</span>
                  <span style={{color:C.text,fontSize:12,fontWeight:700,textAlign:"right",maxWidth:"55%"}}>{v}</span>
                </div>
              ))}
            </div>

            {errorMsg && <div style={{background:C.redL,border:`1px solid ${C.red}30`,borderRadius:12,padding:"10px 12px",color:C.red,fontSize:12,marginBottom:12}}>{errorMsg}</div>}
            <Btn full color={C.green} onClick={()=>{
              const docsOk = form.foto && form.titulo_doc && form.cedula_doc;
              if(!docsOk) return setValidationMsg("Marca los documentos requeridos como cargados para enviar la solicitud.");
              if(!form.acepta_reglamento || !form.acepta_chat) return setValidationMsg("Acepta el reglamento y la regla de chat para enviar la solicitud.");
              guardarSupervisor();
            }}>{saving ? "Guardando..." : "Enviar solicitud de supervisor →"}</Btn>
            <div style={{color:C.muted,fontSize:11,textAlign:"center",marginTop:10}}>Verificamos tu cédula en la SEP · Respuesta en 24–48 horas</div>
          </div>
        )}
      </div>
    </div>
  );
};
